module.exports = __webpack_public_path__ + "static/media/grade6.cb4f3715.jpg";